import { j as c } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const n = e((o, s) => /* @__PURE__ */ c.jsx(
  t,
  {
    ref: s,
    ...o,
    image: (r) => /* @__PURE__ */ c.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...r,
        children: [
          /* @__PURE__ */ c.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M24 40c-8.82 0-16-7.18-16-16S15.18 8 24 8c.41 0 .75.34.75.75s-.34.75-.75.75C16 9.5 9.5 16 9.5 24S16 38.5 24 38.5 38.5 32 38.5 24c0-2.35-.54-4.59-1.62-6.66a.746.746 0 0 1 .32-1.01c.37-.19.82-.05 1.01.32A16 16 0 0 1 40 24c0 8.82-7.18 16-16 16"
            }
          ),
          /* @__PURE__ */ c.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M28.77 32.35c-.06 0-.13-.01-.19-.03l-9.53-2.56a.75.75 0 1 1 .39-1.45l9.53 2.56c.4.11.64.52.53.92-.1.34-.4.56-.73.56M32.01 18.17c-.41 0-.75-.34-.75-.75v-2.75c0-.41.34-.75.75-.75h1.85c2.12 0 3.2-.71 3.2-2.11 0-1.38-2.03-2.31-5.05-2.31-2.52 0-5.07.84-5.07 2.72 0 .41-.34.75-.75.75s-.75-.34-.75-.75c0-2.56 2.58-4.22 6.57-4.22 3.98 0 6.55 1.5 6.55 3.81 0 2.26-1.76 3.61-4.7 3.61h-1.1v2c0 .41-.34.75-.75.75M32 24c-1.24 0-2.24-1.01-2.24-2.24A2.25 2.25 0 0 1 32 19.52a2.25 2.25 0 0 1 2.24 2.24c0 1.23-1 2.24-2.24 2.24m0-2.99c-.41 0-.74.33-.74.74s.33.75.74.75.74-.33.74-.74-.33-.75-.74-.75"
            }
          )
        ]
      }
    )
  }
));
n.displayName = "AgencyConfusedIcon";
export {
  n as AgencyConfusedIcon,
  n as default
};
//# sourceMappingURL=index.js.map
